module.exports = __webpack_public_path__ + "img/english.8188abed.png";